// Home page interactions and UI behavior
// Extracted from inline script for optimization

// Animations on scroll
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
        }
    });
}, observerOptions);

document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
});

// Header scroll effect
window.addEventListener('scroll', () => {
    const header = document.querySelector('.header');
    
    if (window.scrollY > 10) {
        document.body.classList.add('scrolled');
        if (header) {
            header.style.background = 'rgba(255, 255, 255, 0.98)';
            header.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
        }
    } else {
        document.body.classList.remove('scrolled');
        if (header) {
            header.style.background = 'rgba(255, 255, 255, 0.95)';
            header.style.boxShadow = 'none';
        }
    }
}, { passive: true });

// Tag interaction
document.querySelectorAll('.tag').forEach(tag => {
    tag.addEventListener('click', () => {
        const searchInput = document.querySelector('.search-input');
        const tagText = tag.textContent.replace(/[^\w\s]/gi, '').trim();
        searchInput.value = tagText;
        searchInput.focus();
    });
});

// Fill dropdown categories - deferred to idle/load
const fillDropdownCategories = async () => {
  try {
    const API_BASE = (window.apiConfig && window.apiConfig.baseURL) || (function(){ try { return window.location.hostname.match(/localhost|127\.0\.0\.1/) ? `${location.protocol}//${location.hostname}:3000/api/v1` : `${location.origin}/api/v1`; } catch { return `${location.protocol}//${location.hostname}/api/v1`; } })();
    
    // Optimización: Intentar obtener de la cache global si existe (cargada por home-categories.js)
    let cats = window.__popularCategoriesCache || [];
    
    if (!cats.length) {
      const res = await fetch(`${API_BASE}/public/popular-categories?limit=10`);
      if (res.ok) {
        const data = await res.json();
        cats = data?.data?.categories || [];
        // Guardar en cache para otros componentes
        window.__popularCategoriesCache = cats;
      }
    }

    if (!cats.length) {
      const res2 = await fetch(`${API_BASE}/categories`);
      const data2 = await res2.json();
      cats = data2?.data?.categories?.filter(c => !c.parent_id) || [];
    }
    const panel = document.getElementById('categories-dropdown');
    if (!panel) return;
    panel.replaceChildren();
    const list = document.createElement('div');
    list.className = 'dropdown-list';
    const all = document.createElement('a');
    all.className = 'dropdown-item';
    all.href = 'categories.html';
    all.setAttribute('role', 'menuitem');
    all.textContent = 'Ver todas las categorías';
    list.appendChild(all);
    panel.appendChild(list);
    cats.slice(0, 9).forEach(cat => {
      const a = document.createElement('a');
      a.className = 'dropdown-item';
      a.setAttribute('role', 'menuitem');
      a.href = `categories.html?category=${encodeURIComponent(String(cat.slug || ''))}`;
      a.textContent = String(cat.name || cat.slug || '');
      list.appendChild(a);
    });
  } catch(_) {}
};

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => fillDropdownCategories());
} else {
  window.addEventListener('load', fillDropdownCategories);
}

// Accessibility: toggle aria-expanded for Categories menu
const catTrigger = document.querySelector('nav [aria-controls="categories-dropdown"]');
const catPanel = document.getElementById('categories-dropdown');
if (catTrigger && catPanel) {
  const open = () => catTrigger.setAttribute('aria-expanded', 'true');
  const close = () => catTrigger.setAttribute('aria-expanded', 'false');
  catTrigger.addEventListener('mouseenter', open);
  catTrigger.addEventListener('focus', open);
  catPanel.addEventListener('mouseenter', open);
  catPanel.addEventListener('mouseleave', close);
  catTrigger.addEventListener('blur', () => setTimeout(() => {
    if (!catPanel.matches(':hover')) close();
  }, 50));
}

// Modal for subcategories and showcases
const modal = document.getElementById('detalle-modal');
const modalBody = document.getElementById('modal-body');
const closeBtn = document.getElementById('cerrar-modal');

function safeUrl(url) {
  if (!url || typeof url !== 'string') return '';
  try {
    const u = new URL(url, window.location.origin);
    const p = u.protocol.toLowerCase();
    if (p === 'http:' || p === 'https:') return u.href;
    return '';
  } catch {
    return '';
  }
}

if (closeBtn) {
  closeBtn.addEventListener('click', () => { if (modal) modal.style.display = 'none'; });
}

let __homeCatCache = null;
let __homeCatCard = null;

const setModalLoading = (text) => {
  if (!modalBody) return;
  modalBody.replaceChildren();
  const p = document.createElement('p');
  p.textContent = text;
  modalBody.appendChild(p);
};

const renderSubcategories = (cat) => {
  if (!modalBody) return;
  __homeCatCache = cat || null;
  modalBody.replaceChildren();

  const h2 = document.createElement('h2');
  h2.textContent = String(cat?.name || 'Categoría');
  const h4 = document.createElement('h4');
  h4.textContent = 'Subcategorías';
  const ul = document.createElement('ul');

  const subs = Array.isArray(cat?.subcategories) ? cat.subcategories : [];
  subs.forEach((sub) => {
    const li = document.createElement('li');
    const btn = document.createElement('button');
    btn.className = 'subcat-btn';
    btn.setAttribute('data-subslug', String(sub?.slug || ''));
    btn.style.background = 'var(--primary-light)';
    btn.style.color = 'white';
    btn.style.border = 'none';
    btn.style.padding = '0.5rem 1rem';
    btn.style.margin = '0.25rem';
    btn.style.borderRadius = '0.5rem';
    btn.style.cursor = 'pointer';
    btn.textContent = String(sub?.name || sub?.slug || '');
    li.appendChild(btn);
    ul.appendChild(li);
  });

  modalBody.appendChild(h2);
  modalBody.appendChild(h4);
  modalBody.appendChild(ul);
};

const renderBusinesses = (subName, businesses) => {
  if (!modalBody) return;
  modalBody.replaceChildren();

  const h2 = document.createElement('h2');
  h2.textContent = `Vitrina de ${String(subName || '')}`;
  modalBody.appendChild(h2);

  if (Array.isArray(businesses) && businesses.length) {
    const ul = document.createElement('ul');
    businesses.forEach((b) => {
      const li = document.createElement('li');
      li.style.cssText = 'display:flex;align-items:center;gap:0.5rem;padding:0.4rem 0;';
      const logo = safeUrl(String(b?.logo_url || ''));
      if (logo) {
        const img = document.createElement('img');
        img.src = logo;
        img.width = 32;
        img.alt = '';
        img.style.cssText = 'vertical-align:middle;border-radius:50%;flex-shrink:0;';
        li.appendChild(img);
      }
      const nameSpan = document.createElement('span');
      nameSpan.style.flex = '1';
      nameSpan.textContent = String(b?.name || '');
      li.appendChild(nameSpan);
      // Botón Me Gusta ❤️
      try {
        const bizId = String(b?.id || b?._id || '');
        if (bizId && window.LikesUI && typeof window.LikesUI.createLikeButton === 'function') {
          const likeOptions = {};
          if (typeof b?.likes_count === 'number') likeOptions.count = b.likes_count;
          const likeBtn = window.LikesUI.createLikeButton(bizId, likeOptions);
          if (likeBtn) {
            likeBtn.style.flexShrink = '0';
            li.appendChild(likeBtn);
          }
        }
      } catch (_) {}
      ul.appendChild(li);
    });
    modalBody.appendChild(ul);
  } else {
    const p = document.createElement('p');
    p.textContent = 'No hay negocios destacados.';
    modalBody.appendChild(p);
  }

  const back = document.createElement('button');
  back.id = 'volver-subcats';
  back.type = 'button';
  back.style.marginTop = '1rem';
  back.textContent = 'Volver a subcategorías';
  modalBody.appendChild(back);
};

try {
  if (modalBody && !modalBody.__homeBound) {
    modalBody.__homeBound = true;
    modalBody.addEventListener('click', async (e) => {
      const t = e.target;
      if (!t) return;

      const back = t.closest ? t.closest('#volver-subcats') : null;
      if (back) {
        if (__homeCatCache) renderSubcategories(__homeCatCache);
        return;
      }

      const btn = t.closest ? t.closest('.subcat-btn') : null;
      if (!btn) return;
      const subslug = btn.getAttribute('data-subslug') || '';
      const subName = btn.textContent || '';
      setModalLoading('Cargando negocios destacados...');
      try {
        const bizRes = await fetch(`/api/v1/businesses?category=${encodeURIComponent(subslug)}&is_featured=true`);
        const bizData = await bizRes.json();
        const vitrinas = bizData?.data?.businesses || [];
        renderBusinesses(subName, vitrinas);
      } catch {
        setModalLoading('Error cargando la categoría.');
      }
    });
  }
} catch {}

document.querySelectorAll('.category-card').forEach(card => {
  card.addEventListener('dblclick', async () => {
    const slug = card.dataset.category;
    __homeCatCard = card;
    if (modal) modal.style.display = 'flex';
    setModalLoading('Cargando subcategorías...');
    try {
      const res = await fetch(`/api/v1/categories/${slug}`);
      const data = await res.json();
      const cat = data.data.category;
      if (cat.subcategories && cat.subcategories.length) {
        renderSubcategories(cat);
      } else {
        modalBody.replaceChildren();
        const h2 = document.createElement('h2');
        h2.textContent = String(cat?.name || 'Categoría');
        const p = document.createElement('p');
        p.textContent = 'No hay subcategorías.';
        modalBody.appendChild(h2);
        modalBody.appendChild(p);
      }
    } catch(e) {
      setModalLoading('Error cargando la categoría.');
    }
  });
});
